import React from "react";

const HowItWorksCard = ({ title, image, text, point }) => {
  return (
    <div className="how-it-works__card ml-16 mr-16">
      <img
        src={image}
        className="mb-20"
        alt={title}
      />
      <div className="point">
        <span>{point}</span>
      </div>
      <p className="mb-8 text-color-grey">
        <strong className="text-color-grey-900">{title}</strong>
      </p>
      <p className="medium-text">{text}</p>
    </div>
  );
};

export default HowItWorksCard;
